<db-header design="2.0" class="w-100" [fluid]="true" dbHeaderLinkConfig [shouldRemoveLogoLink]="true">
  @if (width > 850) {
    <div class="db-header-base__link-item text-white">
      <a class="text-white text-decoration-none link"
        href="{{ 'HEADER.' + getAppThemeName() + '.link_2.href' | translate }}" target="_blank">
        {{ 'HEADER.' + getAppThemeName() + '.link_2.text' | translate }}
      </a>
    </div>
    <div class="db-header-base__link-item">
      <a class="text-white text-decoration-none link"
        href="{{ 'HEADER.' + getAppThemeName() + '.link_1.href' | translate }}" target="_blank">
        {{ 'HEADER.' + getAppThemeName() + '.link_1.text' | translate }}
      </a>
    </div>
  }
  <div class="ms-auto">
    <language-menu color="#fff"></language-menu>
  </div>
  <div class="ms-5">
    @if (isAuthenticated$ | async) {
      <a class="logout-link" href="#" (click)="onLogout()"><db-icon class="mr-1"
          color="#fff" size="md">document-sent</db-icon>{{'GLOBAL.logout_btn_txt' |
        translate}}</a>
    }
  </div>
  @if (width < 850) {
    <db-menu [iconOnly]="true" design="tertiary" [label]="iconLabel">
      <db-menu-item>
        <div class="db-header-base__link-item">
          <a class="text-white text-decoration-none"
            href="{{ 'HEADER.' + getAppThemeName() + '.link_1.href' | translate }}" target="_blank">
            {{ 'HEADER.' + getAppThemeName() + '.link_1.text' | translate }}
          </a>
        </div>
      </db-menu-item>
      <db-menu-item>
        <div class="db-header-base__link-item text-white">
          <a class="text-white text-decoration-none"
            href="{{ 'HEADER.' + getAppThemeName() + '.link_2.href' | translate }}" target="_blank">
            {{ 'HEADER.' + getAppThemeName() + '.link_2.text' | translate }}
          </a>
        </div>
      </db-menu-item>
    </db-menu>
  }
</db-header>

<ng-template #iconLabel>
  <db-icon size="md" color="#fff">menu</db-icon>
</ng-template>
